import React, {Suspense, lazy} from 'react';
import {ROUTE_PRODUCT_DETAILING_REPORT} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const ProductDetailing = lazy( () =>
  import('../../../screens/ProductDetailingReport')
    .then(module => ({default: module.ProductDetailingReport})));

const ProductDetailingNavigation = [
  {
    path: ROUTE_PRODUCT_DETAILING_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ProductDetailing />
      </Suspense>
    ),
  },
];

export default ProductDetailingNavigation;
